import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { pure } from 'recompose'

import { selectors as UsersSelectors } from 'data/users'
import Timeago from 'components/Utils/Timeago'

const VersionRow = ({ version, isActive, setActiveVersionNum, usernames }) => {
  const authors =
    usernames.length > 0
      ? usernames.map(username => `@${username}`).join(', ')
      : 'Slitebot'

  return (
    <div
      onClick={() => setActiveVersionNum(version.get('to'))}
      className={classNames(
        'pointer',
        'flexbox flexbox-column flexbox-justify-center',
        'padding-vertical-normal padding-horizontal-large',
        'shade-10',
        {
          'background-shade-50-on-hover background-shade-45-on-active': !isActive,
          'background-shade-50': isActive,
        }
      )}
    >
      <div className={classNames('padding-bottom-smaller bold', {})}>
        {authors}
      </div>

      <div
        className={classNames('font-size-small margin-bottom-smaller shade-30')}
      >
        <Timeago date={version.get('createdAt')} />
      </div>
    </div>
  )
}

export default pure(
  connect((state, { version }) => ({
    usernames: version
      .get('userIds')
      .map(userId => UsersSelectors.getUser(state, userId))
      .filter(x => x)
      .map(user => user.get('username')),
  }))(VersionRow)
)
